import styled from 'styled-components';
import AlmirahSvg from '../../assets/amenities/almirah.svg';

const AlmirahIcon = styled(AlmirahSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '2.4rem'};
  height: ${props => props.height || '2.4rem'};
  margin: ${props => props.margin};
`;

export default AlmirahIcon;
